import { useApi } from '../composables/useApi'
import { URLS } from '../constants/urls'

export default function atendimentoRapidoService() {
	const api = useApi()

	async function getAtendimentosFundacao(idFundacoes) {
		return await api.query(
			`${window.origin}${URLS.info_data_politica_fundacao}?fundacao=${idFundacoes}`
		)
	}

	async function createAtendimentoRapido(data) {
		return api.mutation(
			`${window.origin}${URLS.atendimento_rapido_fundacao}`,
			'post',
			data
		)
	}

	return {
		getAtendimentosFundacao,
		createAtendimentoRapido,
		...api,
	}
}
